import type {
	MenuItemLinks,
	NavBarItem,
	NavBarLinkItem,
	NavBarMenuItem,
} from '@ds-mgnl/marketing';

export const topNavData: NavBarItem[] = [
	{
		type: 'submenu',
		label: 'Features',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'Tools',
								path: '/features/tools',
								value: '/features/tools',
								openInNewTab: false,
							},
							{
								label: 'Capabilities',
								path: '/features/capabilities',
								value: '/features/capabilities',
								openInNewTab: false,
							},
							{
								label: 'Integrations',
								path: '/features/integrations',
								value: '/features/integrations',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'Solutions',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'Admissions Workflow',
								path: '/solutions/admissions-workflow',
								value: '/solutions/admissions-workflow',
								openInNewTab: false,
							},
							{
								label: 'Post-Acute Referral Management',
								path: '/solutions/post-acute-referral-management',
								value: '/solutions/post-acute-referral-management',
								openInNewTab: false,
							},
							{
								label: 'Patient Navigation Software',
								path: '/solutions/patient-navigation-software',
								value: '/solutions/patient-navigation-software',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'We serve',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: 'Facilities',
						links: [
							{
								label: 'SNF leaders',
								path: '/we-serve/#snf-leaders',
								value: '/we-serve/#snf-leaders',
								openInNewTab: false,
							},
							{
								label: 'Facility administrators',
								path: '/we-serve/#facility-administrators',
								value: '/we-serve/#facility-administrators',
								openInNewTab: false,
							},
							{
								label: 'Nursing staff',
								path: '/we-serve/#nursing-staff',
								value: '/we-serve/#nursing-staff',
								openInNewTab: false,
							},
						],
					},
				],
			},
			{
				type: 'divider',
			},
			{
				type: 'links',
				linkGroups: [
					{
						label: 'Front Offices',
						links: [
							{
								label: 'Business office',
								path: '/we-serve/#business-office',
								value: '/we-serve/#business-office',
								openInNewTab: false,
							},
							{
								label: 'Business development',
								path: '/we-serve/#business-development',
								value: '/we-serve/#business-development',
								openInNewTab: false,
							},
						],
					},
				],
			},
			{
				type: 'divider',
			},
			{
				type: 'links',
				linkGroups: [
					{
						label: 'Hospitals',
						links: [
							{
								label: 'Hospital case management',
								path: '/we-serve/#hospital-case-management',
								value: '/we-serve/#hospital-case-management',
								openInNewTab: false,
							},
							{
								label: 'Hospital leaders',
								path: '/we-serve/#hospital-leaders',
								value: '/we-serve/#hospital-leaders',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'Resources',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'Support',
								path: '/contact/support',
								value: '/contact/support',
								openInNewTab: false,
							},
							{
								label: 'Expertise',
								path: '/resources/blogs/',
								value: '/resources/blogs/',
								openInNewTab: false,
							},
							{
								label: 'All resources',
								path: '/resources',
								value: '/resources',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'link',
		link: {
			label: 'Company',
			path: '/about',
			value: '/about',
			openInNewTab: false,
		},
	} as NavBarLinkItem,
	{
		type: 'link',
		link: {
			label: 'Contact',
			path: '/contact',
			value: '/contact',
			openInNewTab: false,
		},
	} as NavBarLinkItem,
];
